




















import { defineComponent } from "@vue/composition-api";
import TinyAvatar from "./TinyAvatar.vue";
import UserModel from "@/ts/models/userClass";

export default defineComponent({
  name: "UserChip",

  props: {
    user: Object as () => UserModel
  },

  components: {
    TinyAvatar
  },

  setup() {
    return {};
  }
});
